import React, { useEffect, useState,  } from 'react';
import { useParams, Link } from 'react-router-dom';
import ShareButton from './icon/shareicome';
import RepostButton from './icon/repostbutton';
import { useNavigate } from 'react-router-dom';
import Loading  from './icon/loading';

import LoginButtons from './icon/loginicon';
import { resolveAvatarUrl, handleAvatarError } from '../utils/profilePicUrl';
import { getMediaMimeType, isMediaImage, isMediaVideo } from '../utils/mediaDetect';
import PostMediaGrid from './shared/PostMediaGrid';
import AuthorNameLink from './shared/AuthorNameLink';
import FitCoverImage from './shared/FitCoverImage';
import { sanitizeHtml, htmlToExcerpt } from '../utils/sanitizeHtml';
import ReactionButton from './shared/ReactionButton';
import RepostModal from './shared/RepostModal';
import { DEFAULT_REACTION } from '../utils/reactions';
import { createLinkifiedText } from '../utils/mentions';
import { getAuthorDisplayName, formatAuthorMetaLine } from '../utils/displayName';


const PublicPostDetail = ({ user }) => {
      const navigate = useNavigate();


  const { id } = useParams();
   const [expandedContent, setExpandedContent] = useState({});
  const [visibleCount, setVisibleCount] = useState(5);
  const [loading, setLoading] = useState(true);      // ✅ Add this
  const [error, setError] = useState(null);   
  const [post, setPost] = useState(null);
  const [likes, setLikes] = useState({});
  const [userLiked, setUserLiked] = useState({});
  const [userReactions, setUserReactions] = useState({});
  const [reposts, setReposts] = useState({});
  const [userReposted, setUserReposted] = useState({});
  const [userCaptions, setUserCaptions] = useState({});
  const [showRepostModal, setShowRepostModal] = useState(false);
  const [repostSubmitting, setRepostSubmitting] = useState(false);
  const [replies, setReplies] = useState([]);
  const [replyText, setReplyText] = useState('');
  const [loadingReply, setLoadingReply] = useState(false);
const [popupPhoto, setPopupPhoto] = useState(null);
 const [showFullContent, setShowFullContent] = useState({}); 
const [expandedPostId, setExpandedPostId] = useState(null);
  const closePopup = () => setPopupPhoto(null);

  const API_URL= process.env.REACT_APP_API_URL;

    const toggleContent = (postId) => {
    setShowFullContent((prevState) => ({
      ...prevState,
      [postId]: !prevState[postId],
    }));
  };

// Utility to truncate by word
const getShortContent = (text, wordLimit = 100) => {
  const words = text.split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;
};

const formatTimeAgo = (dateString) => {
  const diff = Date.now() - new Date(dateString).getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return 'Just now';
};



useEffect(() => {
  let isCancelled = false;

  const fetchPost = async () => {
    setPost(null);
    setReplies([]);
    setLikes({});
    setUserLiked({});
    setUserReactions({});
    setReposts({});
    setUserReposted({});
    setError(null);
    setLoading(true);

    // ✅ Ensure numeric ID
    const numericId = parseInt(id, 10);
    console.log("Fetching post ID:", numericId);

    if (isNaN(numericId)) {
      setError("Invalid post ID.");
      setLoading(false);
      return;
    }

    try {
      // ✅ Cache-busting query param
      const res = await fetch(
        `${API_URL}/get_publicpost.php?post_id=${numericId}`
      );
      const data = await res.json();

      if (!isCancelled) {
        if (data.success && Array.isArray(data.posts) && data.posts.length > 0) {
          setPost(data.posts[0]);
          setLikes(data.total_likes || {});
          setUserLiked(data.user_liked || {});
          setUserReactions(data.user_reactions || {});
          if (Array.isArray(data.posts[0].replies)) {
            setReplies(data.posts[0].replies);
          }
        } else {
          setError("Post not found.");
        }
      }
    } catch (err) {
      if (!isCancelled) {
        setError("Error fetching post.");
      }
    } finally {
      if (!isCancelled) {
        setLoading(false);
      }
    }
  };

  fetchPost();

  return () => {
    isCancelled = true;
  };
}, [id]);



 useEffect(() => {
  if (!post?.id) return;

  const fetchLikes = async () => {
    try {
      const userId = user?.id || 0; // fallback to 0 if user not logged in
      const res = await fetch(`${API_URL}/get_likes.php?user_id=${userId}`);
      const data = await res.json();

      if (data.success) {
        setLikes(data.total_likes || {});
        setUserLiked(data.user_liked || {});
        setUserReactions(data.user_reactions || {});
      } else {
        console.warn('Failed to load like data');
      }
    } catch (err) {
      console.error('Error fetching likes:', err.message);
    }
  };

  const fetchReposts = async () => {
    try {
      const userId = user?.id || 0;
      const res = await fetch(`${API_URL}/get_reposts.php?user_id=${userId}`);
      const data = await res.json();
      if (data.success) {
        setReposts(data.total_reposts || {});
        setUserReposted(data.user_reposted || {});
        setUserCaptions(data.user_captions || {});
      }
    } catch (err) {
      console.error('Error fetching reposts:', err.message);
    }
  };

  fetchLikes();
  fetchReposts();
}, [user?.id, post?.id]);






if (loading) return <div><Loading /></div>;
if (error) return <p>{error}</p>;
if (!post) return null;

const handleShare = (id) => {
    console.log("Sharing post ID:", id);
  const shareUrl = `${window.location.origin}/home/public/${id}`;

  if (navigator.share) {
    navigator
      .share({
        title: 'Check out this post!',
        url: shareUrl,
      })
      .then(() => console.log('Post shared successfully'))
      .catch((err) => console.error('Error sharing', err));
  } else {
    navigator.clipboard.writeText(shareUrl);
    alert('Link copied to clipboard!');
  }
};

const openRepostModal = () => {
  if (!user?.id) {
    alert('Please log in first to repost.');
    return;
  }
  setShowRepostModal(true);
};

const submitRepost = async (caption) => {
  if (!post?.id || !user?.id) return;
  const key = String(post.id);
  const already = !!userReposted[key];
  setRepostSubmitting(true);
  try {
    const res = await fetch(`${API_URL}/repost.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id: user.id,
        post_id: post.id,
        action: 'repost',
        caption: caption || '',
      }),
    });
    const data = await res.json();
    if (data.success) {
      setReposts((prev) => ({
        ...prev,
        [key]: typeof data.repost_count === 'number'
          ? data.repost_count
          : Math.max(0, (prev[key] || 0) + (already ? 0 : 1)),
      }));
      setUserReposted((prev) => ({ ...prev, [key]: true }));
      setUserCaptions((prev) => ({ ...prev, [key]: data.caption ?? caption ?? '' }));
      setShowRepostModal(false);
    } else {
      alert(data.message || 'Repost failed');
    }
  } catch (err) {
    console.error('Repost request failed:', err.message);
    alert('Network error: ' + err.message);
  } finally {
    setRepostSubmitting(false);
  }
};

const unrepostFromModal = async () => {
  if (!post?.id || !user?.id) return;
  const key = String(post.id);
  setRepostSubmitting(true);
  try {
    const res = await fetch(`${API_URL}/repost.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id: user.id,
        post_id: post.id,
        action: 'unrepost',
      }),
    });
    const data = await res.json();
    if (data.success) {
      setReposts((prev) => ({
        ...prev,
        [key]: typeof data.repost_count === 'number'
          ? data.repost_count
          : Math.max(0, (prev[key] || 1) - 1),
      }));
      setUserReposted((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
      setUserCaptions((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
      setShowRepostModal(false);
    } else {
      alert(data.message || 'Failed to undo repost');
    }
  } catch (err) {
    console.error('Unrepost request failed:', err.message);
    alert('Network error: ' + err.message);
  } finally {
    setRepostSubmitting(false);
  }
};


const isImage = (url, type) => isMediaImage(url, type);
const isVideo = (url, type) => isMediaVideo(url, type);
const getMimeType = (url, type) => getMediaMimeType(url, type);


 const handleLike = async (targetId, type = 'post', reactionType = DEFAULT_REACTION) => {
  if (!user?.id) {
    alert('Please log in first to like this post.');
    return;
  }

  const key = `${type}_${targetId}`;
  const liked = userLiked[key];
  const currentReaction = userReactions[key] || DEFAULT_REACTION;
  const removing = reactionType === null || (liked && reactionType === currentReaction);
  const changing = liked && !removing && reactionType !== currentReaction;
  const url = removing ? 'unlike.php' : 'like.php';

  try {
    const body = {
      user_id: user.id,
      target_id: targetId,
      target_type: type,
    };
    if (!removing) {
      body.reaction_type = reactionType || DEFAULT_REACTION;
    }

    const res = await fetch(`${API_URL}/${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(body),
    });

    const data = await res.json();

    if (data.success) {
      const nextReaction = removing
        ? null
        : data.reaction_type || reactionType || DEFAULT_REACTION;

      setLikes((prev) => ({
        ...prev,
        [key]: removing
          ? Math.max(0, (prev[key] || 1) - 1)
          : changing
            ? (prev[key] || 1)
            : (prev[key] || 0) + 1,
      }));

      setUserLiked((prev) => ({
        ...prev,
        [key]: !removing,
      }));

      setUserReactions((prev) => {
        const next = { ...prev };
        if (removing) delete next[key];
        else next[key] = nextReaction;
        return next;
      });
    } else {
      if (!liked && data.message !== 'Already liked') {
        alert(data.message || 'Like failed');
      }
    }
  } catch (err) {
    console.error('Like/unlike request failed:', err.message);
    alert('Please log in first to like this post.');
  }
};




  return (
    <>
    <div style={{ background: '#f5f7fa', padding: '40px 20px', minHeight: '100vh' }}>
      <div
        style={{
          background: '#fff',
          maxWidth: '800px',
          margin: '0 auto',
          padding: '30px',
          borderRadius: '12px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
        }}
      >
        <button
          onClick={() => navigate('/login')}
          style={{
            background: 'none',
            border: 'none',
            color: '#007bff',
            fontWeight: 'bold',
            marginBottom: '24px',
            cursor: 'pointer',
          }}
        >
        <LoginButtons />Please log in to join the discussion.
        </button>

        <h1 style={{ fontSize: '1.75rem', color: '#222' }}>
          {post.post_type === 'repost' ? null : post.title}
        </h1>

        <div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '10px', // spacing between profile and name
    fontSize: '0.95rem',
    color: '#777',
    margin: '10px 0 20px',
  }}
>
  {/* Profile Picture */}
  <img
    src={resolveAvatarUrl(post, API_URL)}
    onError={handleAvatarError}
    alt="avatar"
    style={{
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      objectFit: 'cover',
    }}
  />

  {/* Username + metadata */}
  <div>
    <strong style={{ color: '#222' }}>
      <AuthorNameLink user={post} />
      {post.post_type === 'repost' && (
        <span style={{ fontWeight: 500, color: '#65676b', marginLeft: 6 }}>
          reposted
        </span>
      )}
    </strong><br />
    <span style={{ fontSize: '12px', color: '#666' }}>
      {post.category} · {new Date(post.created_at).toLocaleString()}
    </span>
  </div>
</div>

  <div style={{ marginBottom: '20px' }}>
     {post.post_type === 'article' || post.post_type === 'blog' ? (
       <>
         {post.cover_image && (
           <img
             src={post.cover_image}
             alt=""
             style={{
               width: '100%',
               maxHeight: 320,
               objectFit: 'cover',
               borderRadius: 10,
               marginBottom: 16,
             }}
           />
         )}
         <div
           style={{ fontSize: 16, lineHeight: 1.7, color: '#1e293b' }}
           dangerouslySetInnerHTML={{ __html: sanitizeHtml(String(post.content || '')) }}
         />
       </>
     ) : post.post_type === 'hiring' || post.post_type === 'looking_for_job' ? (
       <>
         <FitCoverImage src={post.cover_image} maxHeight={400} radius={10} marginBottom={16} />
         {post.post_type === 'looking_for_job' &&
           Array.isArray(post.looking_for_job_skills) &&
           post.looking_for_job_skills.length > 0 && (
           <p style={{ fontSize: 13, color: '#475569', marginBottom: 12 }}>
             Skills: {post.looking_for_job_skills.join(' · ')}
           </p>
         )}
         {(post.looking_for_job_portfolio_url || post.looking_for_job_contact_email) && (
           <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
             {post.looking_for_job_portfolio_url && (
               <a
                 href={post.looking_for_job_portfolio_url}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{ color: '#1d4ed8', marginRight: 12 }}
               >
                 Portfolio
               </a>
             )}
             {post.looking_for_job_contact_email && (
               <a
                 href={`mailto:${post.looking_for_job_contact_email}`}
                 style={{ color: '#1d4ed8' }}
               >
                 Email
               </a>
             )}
           </p>
         )}
         <div
           style={{ fontSize: 16, lineHeight: 1.7, color: '#1e293b' }}
           dangerouslySetInnerHTML={{
             __html: sanitizeHtml(
               String(
                 post.hiring_description ||
                   post.looking_for_job_description ||
                   post.content ||
                   post.text ||
                   ''
               )
             ),
           }}
         />
       </>
     ) : post.post_type === 'repost' ? (
       <>
         {!!String(post.content || post.repost_caption || '').trim() &&
           String(post.content || post.repost_caption || '').trim() !== 'Repost' && (
           <p
             style={{
               fontSize: '15px',
               color: '#374151',
               marginBottom: '12px',
               whiteSpace: 'pre-wrap',
             }}
             dangerouslySetInnerHTML={{
               __html: createLinkifiedText(String(post.content || post.repost_caption || '')),
             }}
           />
         )}
         {post.original_post && (() => {
           const original = post.original_post;
           const excerptSource =
             original.hiring_description ||
             original.looking_for_job_description ||
             original.text ||
             original.content ||
             '';
           const excerpt = htmlToExcerpt(excerptSource, 220);
           return (
             <div
               style={{
                 border: '1px solid #e5e7eb',
                 borderRadius: 12,
                 padding: 14,
                 background: '#fafafa',
               }}
             >
               <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                 <img
                   src={resolveAvatarUrl(original, API_URL)}
                   alt=""
                   onError={handleAvatarError}
                   style={{
                     width: 36,
                     height: 36,
                     borderRadius: '50%',
                     objectFit: 'cover',
                     background: '#e5e7eb',
                   }}
                 />
                 <div>
                   <div style={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>
                     {getAuthorDisplayName(original)}
                   </div>
                   <div style={{ fontSize: 12, color: '#6b7280' }}>
                     {formatAuthorMetaLine(original, formatTimeAgo)}
                   </div>
                 </div>
               </div>
               {original.title && original.title !== 'Repost' && (
                 <div style={{ fontWeight: 700, fontSize: 16, color: '#102a43', marginBottom: 6 }}>
                   {original.title}
                 </div>
               )}
               {excerpt && (
                 <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.5 }}>
                   {excerpt}
                 </div>
               )}
               {Array.isArray(original.media) && original.media[0] && isImage(original.media[0].url, original.media[0].type) && (
                 <img
                   src={original.media[0].url}
                   alt=""
                   style={{
                     width: '100%',
                     maxHeight: 280,
                     objectFit: 'cover',
                     borderRadius: 10,
                     marginTop: 10,
                     display: 'block',
                   }}
                 />
               )}
               <Link
                 to={`/home/public/${original.id}`}
                 style={{
                   display: 'inline-block',
                   marginTop: 12,
                   fontSize: 13,
                   fontWeight: 600,
                   color: '#0a66c2',
                   textDecoration: 'none',
                 }}
               >
                 View discussion →
               </Link>
             </div>
           );
         })()}
       </>
     ) : (
     <>
     <p
       style={{
         fontSize: "15px",
         color: "#374151",
         marginBottom: "8px",
         whiteSpace: "pre-wrap",
       }}
       dangerouslySetInnerHTML={{
         __html:
           expandedContent[post.id] || post.content.split(" ").length <= 50
             ? createLinkifiedText(String(post.content))
             : createLinkifiedText(
                 String(post.content).split(" ").slice(0, 50).join(" ") + "..."
               ),
       }}
     ></p>
     
     {post.content.split(" ").length > 50 && (
       <button
         onClick={() =>
           setExpandedContent((prev) => ({
             ...prev,
             [post.id]: expandedContent[post.id] ? null : post.content,
           }))
         }
         style={{
           background: "none",
           border: "none",
           color: "#2563eb",
           cursor: "pointer",
           fontSize: "14px",
           padding: 0,
         }}
       >
         {expandedContent[post.id] ? "See less" : "See more"}
       </button>
     )}
     </>
     )}
  </div>
       
  <div>
      {Array.isArray(post.media) && post.media.length > 0 && (
        <PostMediaGrid
          media={post.media}
          onImageClick={setPopupPhoto}
        />
      )}

      {/* Popup */}
      {popupPhoto && (
        <div
          onClick={closePopup}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            cursor: 'pointer',
          }}
        >
          <img
            src={popupPhoto}
            alt="popup"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: '10px',
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}


      </div>

      <hr style={{
  border: 'none',
  borderTop: '2px solid #ddd',
  margin: '5px 0'
}} />
  <div className="post-action-bar" style={{
  display: 'flex',
 
  gap: '12px',
    
}}>

  <ReactionButton
    compact
    showLabel={false}
    iconSize={16}
    count={likes[`post_${post.id}`] || 0}
    userReaction={userReactions[`post_${post.id}`] || null}
    onReact={(reactionType) => handleLike(post.id, 'post', reactionType)}
  />

  {/* Repost Button */}
  <button
    onClick={openRepostModal}
    style={{
      fontSize: '14px',
      color: userReposted[String(post.id)] ? '#0a66c2' : '#28a745',
      fontWeight: 'bold',
      background: 'transparent',
      border: 'none',
      padding: '4px 10px',
      borderRadius: '20px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
    }}
    aria-label={userReposted[String(post.id)] ? 'Edit repost' : 'Repost'}
    title={userReposted[String(post.id)] ? 'Edit repost' : 'Repost'}
  >
    <RepostButton
      count={reposts[String(post.id)] || 0}
      active={!!userReposted[String(post.id)]}
    />
  </button>

  {/* Share Button */}
  <button
    onClick={() => handleShare(post.id)}
    style={{
      fontSize: '14px',
      color: '#28a745',
      fontWeight: 'bold',
      background: 'transparent',
      border: 'none',
      padding: '4px 10px',
      borderRadius: '20px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
 
    }}
  >
    <ShareButton />

  </button>

</div>
     <hr style={{
  border: 'none',
  borderTop: '2px solid #ddd',
  margin: '5px 0'
}} />    
<div style={{ marginTop: '40px' }}>
  <h3>Replies</h3>

  {/* Textarea */}

  {/* Replies List */}
  <div style={{ marginTop: '20px' }}>
    {replies.length === 0 && (
      <div style={{ color: '#888' }}>No replies yet.</div>
    )}

   {replies.slice(0, visibleCount).map((reply) => (
      <div key={reply.id} style={{ marginTop: '15px' }}>
       <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <img
    src={resolveAvatarUrl(reply, API_URL)}
    onError={handleAvatarError}
    alt="avatar"
    style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
  />

  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <strong style={{ fontSize: '14px' }}>
      <AuthorNameLink user={reply} />
    </strong>
    <span style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
      {formatTimeAgo(reply.created_at)} · {reply.category || 'General'} · {reply.location || 'Philippines'}
    </span>
  </div>
</div>

<p
  style={{
    fontSize: "15px",
    color: "#374151",
    marginBottom: "8px",
    whiteSpace: "pre-wrap",
  }}
  dangerouslySetInnerHTML={{
    __html: expandedContent[reply.id] || reply.text.split(" ").length <= 50
      ? createLinkifiedText(String(reply.text))
      : createLinkifiedText(
          String(reply.text).split(" ").slice(0, 50).join(" ") + "..."
        ),
  }}
></p>

{reply.text.split(" ").length > 50 && (
  <button
    onClick={() =>
      setExpandedContent((prev) => ({
        ...prev,
        [reply.id]: prev[reply.id] ? null : reply.text,
      }))
    }
    style={{
      background: "none",
      border: "none",
      color: "#2563eb",
      cursor: "pointer",
      fontSize: "14px",
      padding: 0,
    }}
  >
    {expandedContent[reply.id] ? "See less" : "See more"}
  </button>
)}


        {/* Show media */}
        {Array.isArray(reply.media) &&
          reply.media.map((item, idx) =>
            isVideo(item.url, item.type)
              ? (
                <video
                  key={idx}
                  controls
                  style={{ width: '100%', maxWidth: '300px', marginBottom: '10px' }}
                >
                  <source src={item.url} type={getMimeType(item.url, item.type)} />
                </video>
              )
              : isImage(item.url, item.type) ? (
                <img
                  key={idx}
                  src={item.url}
                  alt="media"
                  style={{ width: '100%', maxWidth: '300px', marginBottom: '10px', borderRadius: '6px' }}
                />
              ) : null
          )}

        <ReactionButton
          compact
          showLabel={false}
          iconSize={14}
          count={likes[`reply_${reply.id}`] || 0}
          userReaction={userReactions[`reply_${reply.id}`] || null}
          onReact={(reactionType) => handleLike(reply.id, 'reply', reactionType)}
        />


        <hr style={{
  border: 'none',
  borderTop: '1px solid #ccc',
  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
  margin: '25px 0'
}} />

      </div>
    ))}
  </div>
</div>

{replies.length > visibleCount && (
  <button
    onClick={() => setVisibleCount(prev => prev + 5)}
    style={{
  marginTop: '15px',
  backgroundColor: '#ffffffff',
  border: 'none', // ✅ removed border
  borderRadius: '6px',
  padding: '8px 16px',
  cursor: 'pointer',
  fontWeight: 'bold',
  color: '#007bff'
}}
  >
    Show more replies
  </button>
)}



        
      </div>
    </div>

    <RepostModal
      open={showRepostModal}
      post={post}
      user={user}
      initialCaption={userCaptions[String(post.id)] || ''}
      alreadyReposted={!!userReposted[String(post.id)]}
      submitting={repostSubmitting}
      onClose={() => {
        if (!repostSubmitting) setShowRepostModal(false);
      }}
      onSubmit={submitRepost}
      onUnrepost={unrepostFromModal}
    />
    </>
  );
}
export default PublicPostDetail;
